module.exports = __webpack_public_path__ + "img/hh.2e528eac.svg";